<section class="chat-shell" [class.is-expanded]="isExpanded()" aria-label="Serg chat assistant">
  <section class="conversation-panel">
    <header class="conversation-header">
      <div class="conversation-title">
        <div class="avatar avatar-small">S</div>
        <div>
          <h1 id="chat-title">{{ chatTitle() }}</h1>
          <span>Private workspace</span>
        </div>
      </div>
      <div class="header-actions">
        <button
          type="button"
          class="icon-button chat-expand-button"
          [class.is-active]="isExpanded()"
          [attr.aria-label]="isExpanded() ? 'Collapse chat' : 'Expand chat'"
          [title]="isExpanded() ? 'Collapse chat' : 'Expand chat'"
          (click)="toggleChatSize()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            @if (isExpanded()) {
              <path d="M5 9V5h4M19 9V5h-4M5 15v4h4M19 15v4h-4" />
            } @else {
              <path d="M7 14v3h3M17 14v3h-3M7 10V7h3M17 10V7h-3" />
            }
          </svg>
        </button>
        <app-option-picker
          [options]="menuOptions"
          [placement]="'down'"
          [ariaLabel]="'Conversation options'"
          [triggerIconSvg]="menuTriggerIcon"
          (valueChange)="onMenuSelect($event)"
        />
      </div>
    </header>

    <app-message-list [messages]="messages()" [topicThreadId]="topicThreadId()"
      [cachedTopics]="cachedTopics()" [isRetrieving]="isRetrieving()" [retrievalStatus]="retrievalStatus()"
      (topicSelected)="askRelatedTopic($event)" />
    <app-message-composer [draft]="draft()" [isThinking]="isThinking()" [model]="model()" [modelOptions]="modelOptions()" [thinkingMode]="thinkingMode()"
      (draftChange)="onDraftChange($event)" (modelChange)="onModelChange($event)" (thinkingModeChange)="thinkingMode.set($event)"
      (attachments)="onComposerAttachments($event)" (messageSubmit)="sendMessage()" (stop)="stopChat()" />

    <!-- Keyword bubbles section removed – handled in parent component -->
  </section>
</section>
